<template>
<div class="site-header">
  <div class="site-header-info">
<!--    <div class="site-header-logo">-->
<!--      <router-link :to="'/'">-->
<!--      <span class="site-header-title">{{siteTitle}}</span>-->
<!--      <span class="site-header-label">{{siteLabel}}</span>-->
<!--      </router-link>-->
<!--    </div>-->
    <div class="site-header-logo2">

    </div>
    <div class="site-header-search">
      <div class="search-select-div" @click="isSelect = !isSelect" @mouseover="isSelect = true" @mouseleave="isSelect = false">
        <div type="text" class="search-selected">{{searchWord}}</div>
        <ul class="search-select" v-if="isSelect">
          <li @click="searchWord='全部';searchType='0'">全部</li>
          <li @click="searchWord='资讯';searchType='1'">资讯</li>
          <li @click="searchWord='政策';searchType='2'">政策</li>
          <li @click="searchWord='通知';searchType='3'">通知</li>
          <li @click="searchWord='展会';searchType='4'">展会</li>
        </ul>
      </div>
      <input type="text" name="site-search" class="search-input" v-model="keyWord" placeholder="输入关键字搜索"/><a @click="searchAct" class="search-button">搜索</a>
      <ul class="search-hot-words" style="display:none">
        <li>热搜：</li>
        <li>突尼斯软子石榴</li>
        <li>软籽石榴</li>
        <li>黄里石榴</li>
        <li>玛瑙石榴</li>
        <li>重磅石榴</li>
        <li>月季石榴</li>
      </ul>
    </div>
    <div class="site-header-login">
      <ul class="site-header-login-act">
        <li><a href="https://yunguowang.weihengag.com/home/user/login.html" target="_blank">个人中心</a></li>
        <li><a href="https://yunguowang.weihengag.com/home/user/login.html" target="_blank">请登录</a></li>
        <li><a href="https://yunguowang.weihengag.com/home/user/register.html" target="_blank">免费注册</a></li>
      </ul>
    </div>
  </div>
  <navbar-view />
</div>
</template>
<script>
import SiteNavbar from './SiteNavbar'

export default {
  name: 'HeadTest',
  components: {
    'navbar-view': SiteNavbar
  },
  data () {
    return {
      siteTitle: this.Global.siteName,
      siteLabel: this.Global.siteLabel,
      isSelect: false,
      searchWord: '全部',
      searchType: '0',
      keyWord: ''
    }
  },
  methods: {
    searchAct () {
      console.log('主页面开始查询，当前路由：' + this.$route.path)
      this.$router.push({path: '/search', query: {keyWord: this.keyWord, type: this.searchType}})
    }
  }
}
</script>
<style>
.site-header {
  width: 100%;
  height: 146px;
  color: #2c3e50;
  background-color:#fff;
}

.site-header-info {
  margin: 0 auto;
  padding: 10px 0px 10px 0px;
  width: 1024px;
  height: 100px;
  background-color:#fff;

}

.site-header-logo {
  float: left;
  width: 220px;
  height: 80px;
  padding-left: 70px;
  background-image: url('./../assets/logo.svg');
  background-color: #ffffff;
  background-size: auto 70px;
  background-repeat: no-repeat;
  background-position: left;
}
.site-header-logo2 {
  float: left;
  width: 280px;
  height: 80px;
  background-image: url('./../assets/logo.png');
  background-color: #ffffff;
  background-size: 90% auto;
  background-repeat: no-repeat;
  background-position: left;
}

.site-header-logo:hover{
  cursor:pointer
}

.site-header-title {
  display: block;
  width: 200px;
  height: 40px;
  font-size: 18px;
  font-weight: 800;
  color: var(--colorH);
  //color:#335116;
  line-height: 50px;
  letter-spacing:5px;
}

.site-header-label {
  display: block;
  width: 200px;
  height: 30px;
  font-size: 14px;
  color:#888;
  line-height:30px;
}

.site-header-search {
  float: left;
  width: 460px;
  margin-left: 30px;
  height: 80px;
  display: flex;
  align-items: center;
  //padding: 10px 0px 5px 0px;
  //background-color:green;
}
.search-select-div{
  position:relative;
  float: left;
  width: 80px;
  height: 40px;
}

.search-select-div:hover{
  background:#fff;
}

.search-selected{
  position:relative;
  float: left;
  width: 80px;
  height: 40px;
  border: 2px solid var(--color6);
  border-right: 0px;
  font-size: 12px;
  font-weight:600;
  line-height:34px;
  text-align:center;
}

.search-selected:hover{
  background:#fff;
  cursor:pointer
}

.search-selected:after{
  content:"\25bc";
  color:#000;
  float:right;
  font-size: 12px;
  transform: scale(.7);
}

.search-select {
  display:block;
  position:absolute;
  top:38px;
  z-index:9999;
  float: left;
  width: 80px;
  outline-style: none;
  font-size: 12px;
  padding-left: 0px;
}

.search-select li{
  list-style: none;
  width: 80px;
  height: 40px;
  font-size:12px;
  //font-weight:600;
  line-height:38px;
  text-align:center;
  background: var(--color6);
  color:#fff;
  padding:0px;
}

.search-select li:hover{
  background: #477931;
  cursor:pointer
}

.search-select .selected{
  display:inline;
  background: red;
}

.search-input {
  display: block;
  float: left;
  width: 400px;
  height: 40px;
  outline-style: none;
  border: 2px solid var(--color6);
  border-left: 0px;
  font-size: 14px;
  padding-left:10px;
}

.search-button {
  display: block;
  float: left;
  width: 100px;
  margin: 0 auto;
  height: 40px;
  text-decoration: none;
  background: var(--color6);
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height: 40px;

}

.search-hot-words {
  width: 500px;
  margin: 0 auto;
  height: 30px;
}

.search-hot-words li {
  list-style: none;
  float: left;
  padding: 0;
  margin: 0 2px 0 2px;
  line-height: 30px;
  color:#aaa;
}

.site-header-login {
  float: right;
  width: 184px;
  height: 80px;
  display: flex;
  align-items: center;
  //padding: 10px 0px 5px 0px;
  //background-color: red;
}

.site-header-login-act {
  width: 184px;
  height: 50px;
}

.site-header-login-act li {
  list-style: none;
  float: left;
  width:33%;
  line-height: 50px;
  text-align:left;
}

.site-header-login-act li a{
  color:#515151
}

.site-header-login-act li a:hover{
  color:var(--color6);
}

#menu {
  font: 12px verdana, arial, sans-serif;
  width: 1104px;
  margin: 0 auto;
  height: 30px;
}

#menu li {
  list-style: none;
  padding: 0;
  margin: 0;
}

#menu li {
  float: left;
}

#menu li a {
  display: block;
  /* 如果是中英文混排的文字，建议用固定宽度
   width:150px;
   height:30px;
   line-height:30px;
   text-align:center;
   */
  padding: 8px 50px;
  background: #3A4953;
  color: #fff;
  text-decoration: none;
  border-right: 1px solid #000;
}

#menu li a:hover {
  background: #146C9C;
  color: #fff;
  text-decoration: none;
  border-right: 1px solid #000;
}

#menu li a.last {
  border-right: 0;
  /* 去掉左侧边框 */
}

.search-button:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue